// 相容性外殼：保留原本「依 contractVersion 分層」的預設匯出形狀，
// 供尚未走 resolveVersion() 轉接層的舊呼叫端（MembershipTransferInSurvey.jsx）繼續使用。
// 實際內容已搬移至 versions/v101~v104/notice.js，此檔案僅重新組裝、不再是資料來源。
import notice101 from '@icoach/documents/membership/create/versions/v101/notice';
import notice102 from '@icoach/documents/membership/create/versions/v102/notice';
import notice103 from '@icoach/documents/membership/create/versions/v103/notice';
import notice104 from '@icoach/documents/membership/create/versions/v104/notice';

export default {
    101: notice101,
    102: notice102,
    103: notice103,
    104: notice104,
};
